import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {PotService} from '../pot.service';
import {PotStock} from '../pot';
import {AddNewStockDialogComponent} from '../add-new-stock-dialog/add-new-stock-dialog.component';
import {BarcodeScannerService} from '../../../barcode-scanner/barcode-scanner.service';
import {SortingService} from '../../../_services/sorting.service';
import {AbstractCountComponent, BedWithVoorraad} from '../../common/abstract-count.component';

export {BedWithVoorraad};

@Component({
  selector: 'app-pot-count',
  templateUrl: './pot-count.component.html',
  styleUrls: ['./pot-count.component.scss']
})
export class PotCountComponent extends AbstractCountComponent<PotStock> {
  protected readonly selectedPositionKey = 'pot-count-selected-position';

  constructor(
    private potService: PotService,
    route: ActivatedRoute,
    dialog: MatDialog,
    barcodeScannerService: BarcodeScannerService,
    sortingService: SortingService
  ) {
    super(route, dialog, barcodeScannerService, sortingService);
  }

  protected fetchBedNrs(): Observable<string[]> {
    return this.potService.getBedNrs();
  }

  protected fetchStockByBedNr(bedNaam: string): Observable<PotStock[]> {
    return this.potService.getPotStockByBedNr(bedNaam);
  }

  protected updateStockItem(stock: PotStock): Observable<any> {
    return this.potService.updateStock(stock);
  }

  openAddStockDialog() {
    this.dialog.open(AddNewStockDialogComponent, {
      width: '600px',
      height: '600px',
      maxWidth: '90%',
      maxHeight: '90%',
    })
      .afterClosed()
      .subscribe(() => this.onAttach());
  }
}
